export type PageDto<T> = {
  totalElements: number;
  content: T[];
};

export const PAGE_DEFAULT: PageDto<any> = {
  totalElements: 0,
  content: [],
};
